// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"GasIndicator_wrapper__fp_p4","gasPrice":"GasIndicator_gasPrice__30s9f","nativePrice":"GasIndicator_nativePrice__pQWaT","gasInfo":"GasIndicator_gasInfo__3vo2f"};